import { Modal } from '@studiometa/ui';
import Media from './Media.js';

/**
 * @typedef {{}} ZoomedGalleryProps
 */

/**
 * ZoomedGallery ZoomedGallery.
 * @augments {Base<ZoomedGalleryProps>}
 */
export default class ZoomedGallery extends Modal {
  isOpen = false;
  imagesAreDisplayed = false;
  zoom = 0;
  index = 0;
  paddingSize = 8;

  /**
   * Class config.
   * @type {import('@studiometa/js-toolkit').BaseConfig}
   */
  static config = {
    name: 'ZoomedGallery',
    components: {
      Media,
    },
    refs: [
      'close',
      'img[]',
      'plus',
      'minus',
      'thumbs[]',
      'wrapper',
      'prev',
      'next',
      'prevThumb',
      'nextThumb',
      'thumbsWrapper',
    ],
  };

  /**
   *
   */
  mounted() {
    this.currentMedia = this.$children.Media[0];
    this.currentImage = this.$refs.img[0];
    this.currentThumb = this.$refs.thumbs[0];

    // Thumbs
    if (this.hasThumbs) {
      this.currentPosition = 0;
      this.thumbHeight = this.$refs.thumbs[0].offsetHeight + this.paddingSize;
      this.wrapperHeight = this.$refs.thumbsWrapper.parentElement.offsetHeight;

      this.visibleThumbs = Math.ceil(this.wrapperHeight / this.thumbHeight);
    }
  }

  /**
   *
   */
  onPrevClick() {
    if (this.index === 0) {
      return;
    }

    this.index -= 1;
    this.setCurrentThumbs();
  }

  /**
   *
   */
  onNextClick() {
    if (this.index === this.$refs.img.length - 1) {
      return;
    }

    this.index += 1;
    this.setCurrentThumbs();
  }

  /**
   *
   */
  onCloseClick() {
    this.closeGallery();
  }

  /**
   * OnThumbsClick
   * @param {object} props
   * @param {number} props.index
   */
  onThumbsClick({ index }) {
    this.index = index;
    this.setCurrentThumbs();
  }

  /**
   * Set current state for elements
   */
  setCurrentThumbs() {
    if (!this.hasThumbs) return;

    this.currentThumb.classList.add('opacity-50');
    this.currentThumb = this.$refs.thumbs[this.index];
    this.currentThumb.classList.remove('opacity-50');

    this.currentMedia = this.$children.Media[this.index];

    this.currentImage.classList.add('hidden');
    this.currentImage = this.$refs.img[this.index];
    this.currentImage.classList.remove('hidden');

    this.setNavState();
  }

  /**
   *
   */
  setNavState() {
    if (this.index === 0) {
      this.$refs.prev.classList.add('opacity-20', 'pointer-events-none');
    } else {
      this.$refs.prev.classList.remove('opacity-20', 'pointer-events-none');
    }

    if (this.index === this.$refs.img.length - 1) {
      this.$refs.next.classList.add('opacity-20', 'pointer-events-none');
    } else {
      this.$refs.next.classList.remove('opacity-20', 'pointer-events-none');
    }
  }

  /**
   *
   */
  onPlusClick() {
    this.currentMedia.setZoomLevel('plus');
  }

  /**
   *
   */
  onMinusClick() {
    this.currentMedia.setZoomLevel('minus');
  }

  /**
   *
   * @param {number} index
   */
  openGallery(index) {
    this.isOpen = true;
    document.body.classList.add('is-panel-open', 'overflow-hidden');

    if (this.hasThumbs) {
      this.$refs.next.classList.add('pointer-events-auto');
      this.$refs.prev.classList.add('pointer-events-auto');
    }
    this.index = index;

    this.setCurrentThumbs();
    this.$el.classList.remove('opacity-0', 'pointer-events-none');
  }

  /**
   *
   */
  closeGallery() {
    this.isOpen = false;
    this.$el.classList.add('opacity-0', 'pointer-events-none');

    if (this.hasThumbs) {
      this.$refs.next.classList.remove('pointer-events-auto');
      this.$refs.prev.classList.remove('pointer-events-auto');
    }

    setTimeout(() => {
      document.body.classList.remove('is-panel-open', 'overflow-hidden');
    }, 200);
  }

  /**
   *
   */
  onNextThumbClick() {
    if (this.$refs.thumbs.length - this.visibleThumbs === this.currentPosition) {
      return;
    }

    this.currentPosition += 1;
    this.$refs.thumbsWrapper.style.transform = `translateY(-${this.currentPosition * this.thumbHeight}px)`;
  }

  /**
   *
   */
  onPrevThumbClick() {
    if (this.currentPosition === 0) {
      return;
    }

    this.currentPosition -= 1;
    this.$refs.thumbsWrapper.style.transform = `translateY(-${this.currentPosition * this.thumbHeight}px)`;
  }

  /**
   * Close panel when type on Escape key
   * @param {object} props Props
   * @param {object} props.ESC Escape key
   * @returns {void}
   */
  keyed({ ESC }) {
    if (ESC) {
      this.closeGallery();
    }
  }

  /**
   * @returns {boolean}
   */
  get hasThumbs() {
    return this.$refs.thumbs.length > 0;
  }
}
